'use strict';

const { interceptorConfig } = require('../../pmtPlacesApp/configs/interceptorConfig.js');
const { statesConfigFactory } = require('../../pmtPlacesApp/configs/statesConfig.js');
const { httpProviderConfig } = require('../../pmtPlacesApp/configs/httpProviderConfig.js');
const { localeConfig } = require('../../pmtPlacesApp/configs/localeConfig.js');
const { bindingsConfig } = require('../../pmtPlacesApp/configs/bindingsConfig.js');
const { runTransitionsSetup } = require('../../pmtPlacesApp/startupFunctions/transitions.js');
const { i18NextFactory } = require('../../pmtPlacesApp/startupFunctions/i18Next.js');
const { setDefaultImgFactory } = require('../../pmtPlacesApp/startupFunctions/images.js');
const { setUpPlanHat } = require('../../pmtPlacesApp/planHat/setup.js');

const { statesConfig } = statesConfigFactory(window);
const { setupI18Next } = i18NextFactory(window);
const { setDefaultImgOnError } = setDefaultImgFactory(document);

angular.module('pmtPlacesApp.controllers', []);
angular.module('pmtPlacesApp.directives', []);
angular.module('pmtPlacesApp.filters', []);
angular.module('pmtPlacesApp.services', []);

angular
	.module('pmtPlacesApp', [
		'ngRoute',
		'ngSanitize',
		'ngAnimate',
		'tmh.dynamicLocale',
		'moment-picker',
		'pmtPlacesApp.services',
		'PinMeTo',
		'pmtPlacesApp.controllers',
		'pmtPlacesApp.directives',
		'pmtPlacesApp.filters',
		'gettext',
		'ngFileUpload',
		'angularMoment',
		'ngNumeraljs',
		'ui.select',
		'ng.deviceDetector',
		'PinMeTo.versionCheck',
		'ui.router'
	])
	.config([
		'$locationProvider',
		'$httpProvider',
		'$animateProvider',
		'$compileProvider',
		interceptorConfig
	])
	.config(statesConfig)
	.config(['$httpProvider', httpProviderConfig])
	.config(localeConfig)
	.config(bindingsConfig)
	.run(runTransitionsSetup);

angular.module('pmtPlacesApp').factory('$exceptionHandler', [
	'pmtLoggerService',
	function (pmtLoggerService) {
		return pmtLoggerService.exceptionHandler;
	}
]);

angular
	.module('pmtPlacesApp')
	.run(['$transitions', 'auth', 'amMoment', 'pmtEnvService', setupI18Next])
	.run(['$transitions', '$location', 'pmtPlanHatService', 'amMoment', setUpPlanHat])
	.run([setDefaultImgOnError]);

// Monkey patch $animate.enabled to fix:
// ui-select problem with input focusing/opening dropdown (when using $animate)
// https://github.com/angular-ui/ui-select/issues/1560#issuecomment-228033704
angular.module('ui.select').run(function ($animate) {
	let origEnabled = $animate.enabled;
	$animate.enabled = function (elem) {
		if (arguments.length !== 1) {
			return origEnabled.apply($animate, arguments);
		} else if (origEnabled(elem)) {
			return /pmt-animate/.test(elem.classNames);
		}
		return false;
	};
});
